import React from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalFooter,
    Card,
    CardBody,
    CardTitle,
    CardText,
    CardSubtitle,
    CardFooter
} from 'reactstrap';
import { setTitle } from './util';
import mfgFetch from "./mfg-fetch";
import {CartesianGrid, BarChart, Bar, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

class ManufacturerAnalytics extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            analytics: [],
            detailedModalState: false,
            detailContent: null,
        };
        setTitle('Manufacturer Analytics');
        this.toggleDetailedInfo = this.toggleDetailedInfo.bind(this);
        this.viewDetailedInfo = this.viewDetailedInfo.bind(this);
    }

    componentWillMount() {
    }


    componentDidMount() {
        this.grabAnalytics();
    }

    grabAnalytics() {
        mfgFetch('/api/v1/mfg/analytics', {
            method: 'GET'
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                this.setState({
                    analytics: body,
                });
            })
            .catch((err) => {
                console.error("Could not get manufacturer's analytical data", err);
            });
    }

    viewDetailedInfo(content) {
        if (!content) {
            return;
        }

        this.setState({
            detailContent: content,
            detailedModalState: true,
        });
    }

    toggleDetailedInfo() {
        this.setState(prevState => ({
            detailedModalState: !prevState.detailedModalState,
        }));
    }

    noData() {
        return (<h4><br />No published content to analyze, view future content analytics here.</h4>);
    }

    render() {
        if (!this.state.analytics || (!this.state.analytics.analytics_content && !this.state.analytics.analytics_logo)) {
            return this.noData();
        }

        let contentAnalytics = [];
        let eduClick = 0;
        let eduLoad = 0;

        let newClick = 0;
        let newLoad = 0;

        let eventsClick = 0;
        let eventsLoad = 0;

        let miscClick = 0;
        let miscLoad = 0;

        if (this.state.analytics.analytics_content) {
            for (let content of this.state.analytics.analytics_content) {
                if (!content || !content.content_analytics) {
                    continue;
                }

                let loaded = 0;
                let clicked = 0;
                let uploaded = new Date(content.content_uploaded);
                let lastUpdated = new Date(content.content_updated);

                for (let adata of content.content_analytics) {
                    switch (adata.analytic_command) {
                        case "LOAD":
                            loaded++;
                            switch (content.content_category) {
                                case "educational":
                                    eduLoad++;
                                    break;
                                case "new":
                                    newLoad++;
                                    break;
                                case "events":
                                    eventsLoad++;
                                    break;
                                case "misc":
                                    miscLoad++;
                                    break;
                            }
                            break;
                        case "CLICK":
                            clicked++;
                            switch (content.content_category) {
                                case "educational":
                                    eduClick++;
                                    break;
                                case "new":
                                    newClick++;
                                    break;
                                case "events":
                                    eventsClick++;
                                    break;
                                case "misc":
                                    miscClick++;
                                    break;
                            }
                            break;
                        default:
                            break;
                    }
                }

                contentAnalytics.push(
                    <Card>
                        <CardBody className="mfg-content-card">
                            <CardTitle><b>{content.content_title}</b></CardTitle>
                            <CardText>
                                <span className="d-flex flex-row justify-content-around">
                                    <span className="content-thumbnail my-auto px-2">
                                        <span className="d-flex flex-column">
                                            <img src={"/content/" + content.content_id + "_t"}
                                                 alt="Content thumbnail"/>
                                        </span>
                                    </span>
                                    <span>
                                        <p><b>Thumbnail Impressions:</b> {loaded} since initial upload</p>
                                        <p><b>Thumbnail Clicks:</b> {clicked} since initial upload</p>
                                        <p><b>Upload Date:</b> {uploaded.toLocaleDateString("en-US")}</p>
                                        <p><b>Last Updated:</b> {lastUpdated.toLocaleDateString("en-US")}</p>
                                        <Button onClick={(e) => this.viewDetailedInfo(content)}>Detailed Analytics</Button>
                                    </span>
                                </span>
                            </CardText>
                        </CardBody>
                    </Card>
                );

            }
        }

        let logoLoads = 0;
        let logoLoads30 = 0;

        if (this.state.analytics.analytics_logo) {
            for (let logoLoad of this.state.analytics.analytics_logo) {
                logoLoads++;
                let now = new Date();
                let logoDate = new Date(logoLoad.analytic_created);
                let diffDays = Math.abs(now.getTime() - logoDate.getTime()) / (1000 * 60 * 60 * 24);
                if (diffDays < 30.0) {
                    logoLoads30++;
                }
            }
        }

        const categoryBarData = [
            {
                "name": "Educational",
                "Thumbnail Clicks": eduClick,
                "Thumbnail Impressions": eduLoad,
            },
            {
                "name": "New Products",
                "Thumbnail Clicks": newClick,
                "Thumbnail Impressions": newLoad,
            },
            {
                "name": "Events",
                "Thumbnail Clicks": eventsClick,
                "Thumbnail Impressions": eventsLoad,
            },
            {
                "name": "Miscellaneous",
                "Thumbnail Clicks": miscClick,
                "Thumbnail Impressions": miscLoad,
            }
        ];

        let barChart = (
            <ResponsiveContainer width="95%" height={350}>
                <BarChart width="95%" height={350} data={categoryBarData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Thumbnail Clicks" fill="#8884d8" />
                    <Bar dataKey="Thumbnail Impressions" fill="#82ca9d" />
                </BarChart>
            </ResponsiveContainer>
        );

        let practiceInfo = [];
        if (this.state.detailContent) {
            if (this.state.detailContent.content_analytics) {
                for (let adata of this.state.detailContent.content_analytics) {
                    let d = new Date(adata.analytic_created);
                    let ac = adata.analytic_command === "CLICK" ? "clicked thumbnail" : "loaded thumbnail";
                    if (!adata.analytic_practice_name) {
                        continue;
                    }

                    let locInfo = [];

                    if (adata.analytic_country) {
                        locInfo.push(
                            <span>Country: {adata.analytic_country}</span>
                        );
                    }

                    if (adata.analytic_region) {
                        locInfo.push(
                            <span className="pl-2">State/Region: {adata.analytic_region}</span>
                        )
                    }

                    practiceInfo.push(
                        <Card>
                            <CardBody>
                                <CardTitle>
                                    Practice {adata.analytic_practice_name} {ac}
                                </CardTitle>
                                <CardSubtitle>
                                    <p className="d-flex flex-row">
                                        <b className="pl-1">{d.toLocaleDateString("en-US")}</b>
                                        <span className="ml-auto">
                                            {locInfo}
                                        </span>
                                    </p>
                                </CardSubtitle>
                            </CardBody>
                        </Card>
                    );
                }
            }
        }

        let detailModal = (
            <Modal isOpen={this.state.detailedModalState} toggle={this.toggleDetailedInfo}>
                <ModalHeader toggle={this.toggleDetailedInfo}>Detailed Analytics</ModalHeader>
                {practiceInfo}
            </Modal>
        );

        return (
            <div className="d-flex flex-column p-1">
                <h3>Basic Statistics</h3>
                <div className="d-flex flex-row justify-content-around">
                    <p>Logo visibility: Logo viewed {logoLoads} times. Of those {logoLoads}, {logoLoads30} were within the last 30 days.</p>
                </div>
                <span className="d-flex flex-row">
                    <span className="d-flex flex-column">
                        <span className="p-1">
                            <h3 className="section-title text-center">Published Content</h3>
                            {contentAnalytics}
                        </span>
                    </span>
                    <span className="stat-chart p-1 pl-2 flex-fill">
                        <h3 className="section-title text-center">Category Information</h3>
                        {barChart}
                    </span>
                </span>
                {detailModal}
            </div>
        );
    }
}

export default ManufacturerAnalytics;